import React, { useEffect, useState } from "react";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import FormList from "./FormList";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";
import Swal from "sweetalert2";

const ReviewSettings = ({ onMouseDown, tableRef }) => {
  const [selectedFormIds, setSelectedFormIds] = useState([]);
  const [schemaList, setSchemaList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [eventName, setEventName] = useState("");
  const [eventLoader, setEventLoader] = useState(false);
  const [formLoader, setFormtLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [schemaId, setSchemaId] = useState("");

  const getEventFormSchema = async () => {
    setLoading(true);
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setSchemaList(data?.data || []);
    setSchemaId((data?.data || [])[0]?.schemaId)
    setLoading(false);
  };

  const getEventBasedonSchema = async () => {
    setEventLoader(true)
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(studyId, schemaId, "all")
    setEventList(data?.data || [])
    setEventLoader(false)
  }

  const getSchemaEventForms = async () => {
    setFormtLoader(true)
    let data = await studyEventManagementServices.getSchemaEventForms(studyId, schemaId, eventId, timePointId || "no", StudyMode)
    setFormList(data?.data || [])
    setFormtLoader(false)
  }

  const getMedicalReviewSettings = async () => {
    let data = await studyMedicalReviewServices.getMedicalReviewSettings(studyId, schemaId, eventId, timePointId || "no")
    setSelectedFormIds(data?.data || [])
  }

  const saveMedicalReviewSettings = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Save Change!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, save it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {}
        userData.studyId = studyId
        userData.schemaId = schemaId
        userData.eventId = eventId
        userData.timePointId = timePointId
        userData.forms = selectedFormIds
        let data = await studyMedicalReviewServices.saveMedicalReviewSettings(userData);
        if (data?.statusCode === 200) {
          getMedicalReviewSettings();
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    getEventFormSchema();
  }, [studyId]);

  useEffect(() => {
    if (schemaId) {
      getEventBasedonSchema();
    }
  }, [schemaId]);
  useEffect(() => {
    if (eventId && schemaId) {
      getSchemaEventForms();
      getMedicalReviewSettings();
    }
  }, [eventId, schemaId, timePointId]);

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack px-2"
        style={{ height: 36 }}
      >
        <div className="hstack justify-content-between gap-1 w-100">
          <Form.Select onChange={(e) => setSchemaId(e.target.value)} style={{ width: 200 }}>
            <option>Select Schema</option>
            {schemaList?.map(schemaData => (
              <option selected={schemaId === schemaData?.schemaId} value={schemaData?.schemaId}>{schemaData?.schemaName}</option>
            ))}
          </Form.Select>
          {formList?.length > 0 &&
            <button
              className={`updateProfile`}
              onClick={saveMedicalReviewSettings}
              disabled={buttonLoader || !studyId || !schemaId || !eventId}
              style={{ fontSize: 12 }}
            >
              {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" />
                Saving...
              </div>
            ) : (
              "Save Settings"
            )}
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="vertical"
        minSize={"20%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {loading || eventLoader ? (
          <PageLoader />
        ) : eventList?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Please Select Schema."} />
          </div>
        ) : (
          <ListGroup className="p-2">
            {eventList?.map((event, index) => (
              <ListGroup.Item
                action
                title={event?.row?.EVENTID}
                onClick={() => {
                  setEventId(event?.eventId);
                  setTimePointId(event?.row?.TIMEPOINTUNIQUEID);
                  setEventName(event?.row?.EVENTID);
                }}
                key={index}
                style={{ padding: "7px 0px 7px 10px" }}
                className={`hstack ${`${eventId}${timePointId || ""}` === `${event?.eventId}${event?.row?.TIMEPOINTUNIQUEID || ""}` ? "selectedMenu" : "bg-white"
                    }`}
              >
                <span>{event?.row?.EVENTID} {event?.row?.TIMEPOINTID && `(${event?.row?.TIMEPOINTID})`}</span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
        {formLoader ? (
          <PageLoader />
        ) : !eventId ? (
          <div className="hstack justify-content-center h-100">
            Click to view Form!
          </div>
        ) : (
          <FormList
            formList={formList}
            onMouseDown={onMouseDown}
            tableRef={tableRef}
            selectedFormIds={selectedFormIds}
            setSelectedFormIds={setSelectedFormIds}
          />
        )}
      </SplitPane>
    </>
  );
};

export default ReviewSettings;
